export default __webpack_public_path__ + "content/media/16.87435d0f.jpg";